const MAPS_API_KEY = "AIzaSyDP6ngoqNFw5g7WJhYWsBjJkbXUy9rMSyI"

export {MAPS_API_KEY}